import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;

uniform vec4 uRectData;
uniform vec4 uProgress;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vPosition;
varying vec3 vWorldPosition;

vec2 RECT_SIZE = vec2(1600.0, 580.0);

void main() {

  ${frustumCull}

  vec2 uv = vUv;
  uv -= 0.5;
  uv *= uRectData.xy / uRectData.y;
  uv /= RECT_SIZE / RECT_SIZE.y; 
  uv += 0.5;

  float l = length(uv * (RECT_SIZE / RECT_SIZE.y));

  l *= mix(0.1, 1.0, uProgress.y);

  vec3 color = uColor1;
  color = mix(mix(color, vec3(1.0), 0.4), color, uProgress.x);
  color = mix(color, uColor2, smoothstep(0.0, 1.0, l));
  color = mix(color, uColor3, smoothstep(1.5, 3.0, l));

  // color = mix(mix(uColor1, vec3(1.0), 0.8), color, uProgress.x);

  color = pow(color, vec3(1.0 / 2.2));

  gl_FragColor = vec4(color,  1.0);
}
`
